/**
 * Import Swiper bundle
 */
import Swiper from 'swiper/bundle';

window.newsSortSwiper = 1;


var ITM = {

    /**
     * Call all functions
     */
    initDom: function () {

        var me = this;


        $(document).ready(function () {


            window._isScrolled = false;
            var $window = $(window);
            var $windowScrollTop = $window.scrollTop();
            var categories;


            if ($('.news-sorting-view').length) {
                me.news();
                me.newsSort($('#newssort'));
                $("form :input").change(function () {
                    me.newsSort($(this).closest('form').data('changed', true));
                });
            }
        });

        window.addEventListener('DOMContentLoaded', function() {
                setTimeout(function() {
                    let message = { height: document.body.scrollHeight};
                window.top.postMessage(message, "*");
                }, 100);
        });
        window.addEventListener('message', function(e) {
            if(e.data == 'getHeight'){
                let message = { height: document.body.scrollHeight};
                window.top.postMessage(message, "*");
            }
        } , false);

    },

    news: function () {
        //Categories
        var container = $('.news-sorting-view');
        var categoriesunfiltered = [];
        newsitems.forEach(function (e) {
            e[1].forEach(function (i) {
                categoriesunfiltered.push(i['title']);
            })
        });

        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }

        var categories = categoriesunfiltered.filter(onlyUnique);

        //Input Categories
        if (newsitems.length > 0) {

            if(categories.length != 0){
                categories.forEach(function (item) {
                    container.find('#newssort #cat').append(
                        '<option value="' + encodeURIComponent(item) + '">' + item + '</option>'
                    );
                })
            }else{
                container.find('#newssort #cat').hide();
            }


        }

        // Swiper baysics

        newsSortSwiper = new Swiper('.newscontainer .swiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next-newssort',
                prevEl: '.swiper-button-prev-newssort',
            },
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 320px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 480px
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                // when window width is >= 640px
                1400: {
                    slidesPerView: 4,
                    spaceBetween: 40
                }
            }
        });
    },

    newsSort: function (form) {
        function objectifyForm(formArray) {
            //serialize data function
            var returnArray = {};
            for (var i = 0; i < formArray.length; i++) {
                returnArray[formArray[i]['name']] = formArray[i]['value'];
            }
            return returnArray;
        }

        if (typeof form != 'undefined') {
            var formdata = objectifyForm($(form[0]).serializeArray());
        }
        var container = $('.news-sorting-view');
        container.find('.items').remove();
        var newscontainer = container.find('.newscontainer .swiper .swiper-wrapper');
        var filtered = [];
        var imgpreload = [];
        var days = formdata['days'];
        var date = formdata['date'];
        var cat = formdata['cat'];

        // Times

        //today
        var today = new Date();
        var t0 = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
        var t24 = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1, 0, 0, 0);

        //tomorrow
        var t48 = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2, 0, 0, 0);

        //current week

        //var monday = new Date(new Date(today.setDate(today.getDate() - today.getDay())).setHours(0, 0, 0, 0));
        //var friday = new Date(new Date(today.setDate(today.getDate() - today.getDay() + 7)).setHours(0, 0, 0, 0));
        var firstDayOfTheWeek = today.getDate()+1 - today.getDay();
        var lastDayOfTheWeek = firstDayOfTheWeek+6
        var monday = new Date(today.setDate(firstDayOfTheWeek)).setHours(1);
        var sunday = new Date(today.setDate(lastDayOfTheWeek)).setHours(23);

        //Cap für Image preloads
        var preloaddate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 60, 0, 0, 0);

        newsitems.forEach(function (item) {
            var eventstart = parseInt(item[0]['starttime']) * 1000;
            var eventendtemp = parseInt(item[0]['endtime']) * 1000;
            var daysoverlap = false;
            var dateoverlap = false;
            var catoverlap = false;
            var eventend;
            if (eventendtemp === 0) {
                eventend = (eventstart + 86400);
            } else {
                eventend = eventendtemp;
            }

            //Tagesauswahl
            switch (days) {
                case 'today':
                    var filterstart = t0.getTime();
                    var filterend = t24.getTime();

                    if (eventstart < filterend && filterstart < eventend) {
                        daysoverlap = true;
                    }
                    break;
                case 'tomorrow':
                    var filterstart = t24.getTime();
                    var filterend = t48.getTime();

                    if (eventstart < filterend && filterstart < eventend) {
                        daysoverlap = true;
                    }
                    break;
                case 'week':
                    var filterstart = monday;
                    var filterend = sunday;
                    if (eventstart < filterend && filterstart < eventend) {
                        daysoverlap = true;
                    }
                    break;
                default:
                    daysoverlap = true;
                    break;
            }

            //Datumsauswahl
            if (date.length > 0) {
                var filterdatestart = new Date(date).getTime();
                var filterdateend = new Date(date).setHours(23);
                var filterstart = filterdatestart;
                var filterend = filterdateend;

                if (eventstart < filterend && filterstart < eventend) {
                    dateoverlap = true;
                }
            } else {
                dateoverlap = true;
            }

            //Kategorieauswahl
            if (cat.length > 0) {
                item[1].forEach(function (itemcat) {
                    if (itemcat['title'] === decodeURIComponent(cat)) {
                        catoverlap = true;
                    }
                })
            } else {
                catoverlap = true;
            }

            if (eventstart < preloaddate) {
                imgpreload.push(item[0]['img']);
            }

            if (dateoverlap === true && daysoverlap === true && catoverlap === true) {
                filtered.push(item);
            }
        });

        function preloadImage(url) {
            var img = new Image();

            img.src = url;

        }

        imgpreload.forEach(function (item) {
            preloadImage(item);


        });

        newscontainer.empty();
        filtered.slice(0, 8).forEach(function (newsitem) {

            var classes = '';
            newsitem[1].forEach(function (e) {
                classes = classes + " " + encodeURIComponent(e['title']);
            });

            var dateoptions = {day: 'numeric', month: 'long', year: 'numeric'};

            var image = newsitem[0]['img'];
            if (newsitem[0]['endtime'] !== '0') {
                var endtime = new Date(parseInt(newsitem[0]['endtime']) * 1000).toLocaleDateString("de-DE", dateoptions);
            }
            var eventlink = newsitem[0]['eventlink'];

            var location = newsitem[0]['location'];
            var price = newsitem[0]['price'];
            var starttime = new Date(parseInt(newsitem[0]['starttime']) * 1000).toLocaleDateString("de-DE", dateoptions);
            var clock = new Date(parseInt(newsitem[0]['starttime']) * 1000).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'});
            var title = newsitem[0]['title'];
            var uid = newsitem[0]['uid'];
            var url = newsitem[0]['url'];
            if (document.documentElement.lang == "nl-nl")
            {
                var infos = "Verdere informatie"
            }
            else {
                var infos = "Weitere Infos"
            }



            var item = ""


            item +=
                '<div class="swiper-slide' + classes + '">\n' +
                '<div class="item' + classes + '">\n'

            item +=
                '    <div class="image">\n'
            if (typeof image != 'undefined' && image != null) {
                item +=
                    '    <img src=' + image + '>'
            }else{
                item +=
                    '    <img src=\'/typo3conf/ext/itm_template/Resources/Public/Images/Stadt_Gescher_Museumslandschaft_Platzhalter_Veranstaltungskalender_0622_L01.jpg\'>'
            }

            item +=
                '    </div>\n'
            item +=
                '    <div class="overlay">\n' +
                '        <div class="title">' + title + '</div>\n' +
                '        <div class="price">' + price + '</div>\n'

            if (typeof location != 'undefined'){
                if (location.length !== 0){
                    item +=
                        '        <div class="location">' + location + '</div>\n'
                }
            }
            if (typeof endtime != 'undefined' && endtime != starttime) {
                if (endtime.length !== 0) {
                    item +=
                        '        <div class="timeframe">' + starttime + ' - ' + endtime + '</div>\n'
                }
            } else if (typeof starttime != 'undefined') {
                if (starttime.length !== 0) {
                    item +=
                        '        <div class="timeframe">' + starttime + '</div>\n'
                }
            }
            if (typeof clock != 'undefined'){
                if (clock.length !== 0){
                    item +=
                        '        <div class="clock">' + clock + ' Uhr</div>\n'
                }
            }
            item +=
                '        <div class="links">\n'

            if (typeof url != 'undefined') {
                if (url.length !== 0) {
                    item +=
                        '            <div class="info"><a class="link" href="' + url + '">' + infos + '</a></div>\n'
                }
            }
            if (eventlink != '') {
                item +=
                    '            <div class="buy"><a class="link" target="_blank" href="' + eventlink + '">Tickets kaufen</a></div>\n'
            }

            item +=
                '        </div>\n' +
                '    </div>\n' +
                '</div>\n' +
                '</div>'


            newscontainer.append(item);
            newsSortSwiper.update();
        });
    }
};

// Init all needed functions
ITM.initDom();